import React, { useRef, useState, useEffect, useCallback } from "react";
import edit from "../../assets/svg/edit.svg";
import del from "../../assets/svg/delete.svg";
import next from "../../assets/svg/next.svg";
import search from "../../assets/svg/search.svg";
import filter from "../../assets/svg/filter.svg";
import uparrow from "../../assets/svg/uparrow.svg";
import table from "../../assets/svg/table.svg";
import column from "../../assets/svg/cloumn.svg";
import { getDockApi, getLocationApi, getStatusApi, getVehicleTypeApi } from "../report/report-api.js";
import df from "../../assets/svg/df.svg";
import Viewdock from "./dockview";
import close from "../../assets/svg/close.svg";
import SearchWithAPI from "../searchbox/searchbox.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AddDock from "./dockadd"; // Import AddDockForm
import { getAvailableDocksApi } from "../Dashboard/dashboard-api";
import right from "../../assets/svg/right.svg";
import left from "../../assets/svg/left.svg";
import { getDockListApi } from "./dock-api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import { format } from "date-fns";
import { Row, Col } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import DockOutModal from "./dock-out-modal.js";
import { useGlobal } from "../../GlobalContext";
import mawalog from "../../assets/svg/mawaloglogo.svg";

const Dock = () => {
  const [dockId,setDockId] = useState(null);
   const [dockOutId,setDockOutId] = useState(null);
  const [pageCount, setPageCount] = useState(0);
 const { refreshDockList, setRefreshDockList } = useGlobal();
  const styles = {
    pagination: {
      display: "flex",
      listStyle: "none",
      gap: "10px",
      justifyContent: "center",
      padding: "10px",
    },
    pageItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "30px",
      height: "30px",
      padding: "10px",
      border: "1px solid #ddd",
      cursor: "pointer",
      borderRadius: "100px",
      fontFamily: "Epilogue",
      fontSize: "12px",
      fontWeight: 500,
    },
    activePage: {
      backgroundColor: "#6929E2",
      color: "white",
      fontWeight: "bold",
    },
  };

  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isAddDockModalOpen, setIsAddDockModalOpen] = useState(false); // Add state for AddDockForm modal

  const [searchText, setSearchText] = useState("");

    //default dropdown
    const [selectedValue, setSelectedValue] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortDir, setSortDir] = useState("");

    const handleChange = (e) => {
      const value = e.target.value;
      setSelectedValue(value);

      if (value) {
        const [field, dir] = value.split(" ");
        setSortField(field);
        setSortDir(dir);
      } else {
        setSortField(""); // Default sort
        setSortDir("");
      }
    };

  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [availableDockList, setAvailableDockList] = useState([]);
  const [dockList, setDockList] = useState([]);
  const [dockCount, setDockCount] = useState(null);

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    createdDate: "",
    sortBy: "",
    selectedUser: "",
    date: "",
  });

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  //filter location
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };

  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const handleVehicleTypeChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedVehicleType(selectedOptions);
    //setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };

  const [dockNumberOption, setDockNumberOption] = useState(null);

  const handleDockNumberDropdownChange = (option) => {
    console.log(option);
    setDockNumberOption(option);
  };

  const [dockType, setDockType] = useState("");
 const [showDockOutModal, setDockOutModal] = useState(false);

  const [dockTypeOptions, setDockTypeOptions] = useState([
    { label: "All", value: "" },
    { label: "Load In", value: "load_in" },
    { label: "Load Out", value: "load_out" },
  ]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fromCreatedDate = startDate ? format(startDate, "yyyy-MM-dd") : "";
  const toCreatedDate = endDate ? format(endDate, "yyyy-MM-dd") : "";

  const [selectedStatus, setSelectedStatus] = useState("All");
  const statusOptions = ["All", "In-Queue", "Dock-In", "On-Time", "Delay", "Over-Delay", "Dock-Out", "Out-Queue"];

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    // Call the API with the selected status
  };

    useEffect(() => {
  getAvailableDocks();
  handleReset();
}, [refreshDockList]);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleReset = () => {
    setSelectedVehicleType(null);
    setDockNumberOption(null);
    setDockType("");
    setStartDate(null);
    setEndDate(null);
    setSelectedLocation(null);
    getDockList();
  };
  useEffect(() => {
  getAvailableDocks();
}, []);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollRef = useRef(null);
  const statusScrollRef = useRef(null);

  const handleScroll = (dir) => {
    const scrollAmount = 200;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleStatusScroll = (dir) => {
    const scrollAmount = 200;
    if (statusScrollRef.current) {
      statusScrollRef.current.scrollBy({
        left: dir === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  //filter
  const calculateDateRange = (filter) => {
    const today = new Date();
    let startDate, endDate;

    switch (filter) {
      case "This week":
        startDate = new Date(today.setDate(today.getDate() - today.getDay()));
        endDate = new Date(today.setDate(startDate.getDate() + 6));
        break;
      case "Last week":
        startDate = new Date(today.setDate(today.getDate() - today.getDay() - 7));
        endDate = new Date(today.setDate(startDate.getDate() + 6));
        break;
      case "This month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "Last month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        startDate = null;
        endDate = null;
    }

    return { startDate, endDate };
  };

  // const handleItemsPerPageChange = (event) => {
  //   setItemsPerPage(Number(event.target.value));
  //   setItemOffset(0);
  // };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % dockList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setItemOffset(0);
  };

  const handleSortChange = (sortOption) => {
    setSortBy(sortOption);

    // Force a refetch by resetting offset
    setItemOffset(0);
  };

  const handleFilterApply = (filters) => {
    // Update sortBy state if it changed in filter
    if (filters.sortBy) {
      setSortBy(filters.sortBy);
    }

    setFilterParams({
      ...filters,
      date: filters.createdDate ? "" : filters.date,
      createdDate: filters.date ? "" : filters.createdDate,
    });
    setIsFilterOpen(false);
    setItemOffset(0);
  };

  const FilterPanel = ({ isOpen, onClose, onApply, initialFilters }) => {
    const [localFilters, setLocalFilters] = useState({
      ...initialFilters,
      sortBy: initialFilters.sortBy || sortBy, // Sync with parent sortBy
    });

    const handleDateOptionChange = (value) => {
      setLocalFilters({
        ...localFilters,
        createdDate: value,
        date: "", // Clear specific date when date option is selected
      });
    };

    const handleSpecificDateChange = (event) => {
      setLocalFilters({
        ...localFilters,
        date: event.target.value,
        createdDate: "", // Clear date option when specific date is selected
      });
    };

    //filter css
    const styles = {
      container: {
        position: "fixed",
        top: 0,
        right: 0,
        transform: isOpen ? "translateX(0)" : "translateX(100%)",
        height: "100%",
        width: "320px",
        backgroundColor: "#fff",
        transition: "transform 0.3s ease-in-out",
        zIndex: 1000,
        fontFamily: "Epilogue",
      },
      panel: {
        padding: "5px 20px 5px 20px",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      },
      title: {
        fontSize: "18px",
        fontWeight: "700",
        fontFamily: "Epilogue",
        color: "#172B4D",
      },
      closeIcon: {
        background: "none",
        border: "1px solid #D4DDE7",
        borderRadius: "100px",
        padding: "8px",
        height: "40px",
        width: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      },
      sectionTitle: {
        fontSize: "16px",
        fontWeight: "700",
        fontFamily: "Epilogue",
        color: "#172B4D",
        marginBottom: "10px",
      },
      radioGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "11px",
      },
      radioLabel: (active) => ({
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "13px",
        fontFamily: "Epilogue",
        paddingTop: "8px",
        paddingBottom: "8px",
        fontWeight: 500,
        lineHeight: "100%",
        letterSpacing: "0%",
        verticalAlign: "middle",
        color: active ? "#D35258" : "#172B4D",
        cursor: "pointer",
      }),
      radioInput: (isActive) => ({
        width: "16px",
        height: "16px",
        border: "2px solid #D35258",
        borderRadius: "50%",
        background: isActive ? "radial-gradient(circle, #D35258 0%, #D35258 40%, transparent 41%)" : "#fff",
        cursor: "pointer",
        transition: "0.2s ease",
        display: "inline-block",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        outline: "none",
      }),

      dateInput: {
        width: "100%",
        padding: "10px",
        height: "36px",
        borderRadius: "12px",
        border: "none",
        backgroundColor: "#FFE9EA",
        color: "#172B4D",
        fontSize: "13px",
        marginTop: "8px",
        outline: "none",
      },
      select: {
        width: "100%",
        height: "36px",
        padding: "10px",
        borderRadius: "12px",
        border: "1px solid #EBEBEB",
        fontSize: "13px",
        outline: "none",
      },
      modalFooter: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
      },
      resetButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: "#f0f0f0",
        color: "#001f3f",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
      applyButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: "#D35258",
        color: "#ffff",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
    };

   

    //filter modal
    return (
      <div>
        <style>{`
        .custom-datepicker {
          background-color: #ffffff !important;
          color: #172b4d !important;
          font-weight: 500 !important;
          font-size: 13px !important;
          cursor: pointer;
          height:40px;
        }
      
        .custom-datepicker::placeholder {
          color: #8790A1 !important;
          font-weight: 500;
          font-size: 13px;
        
        }

        .react-datepicker-wrapper{
          width:100% !important;
        }
      `}</style>
        <div className="container-fluid" style={{ ...styles.container, overflowY: "auto" }}>
          <div className="row" style={styles.panel}>
            <div className="col-12" style={styles.header}>
              <div style={styles.title}>FILTER</div>
              <div style={styles.closeIcon} onClick={onClose}>
                <img src={close} alt="close" style={{ width: "14px", height: "14px" }} />
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Location</div>
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%", borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                    <SearchWithAPI onDropdownChange={handleLocationChange} apiUrl={apiAdminUrl + `get_location`} params={{}} placeholder={"Select"} selectedOption={selectedLocation} />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Dock</div>
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%", borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                    <SearchWithAPI onDropdownChange={handleDockNumberDropdownChange} apiUrl={apiUrl + `dockmaster/autosuggestion`} params={{}} placeholder={"Select"} selectedOption={dockNumberOption} />
                  </div>{" "}
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d", marginBottom: "10px" }}>Dock Type</div>
                <div style={{ width: "100%" }}>
                  <div className="style-justify-start" style={{ flexWrap: "wrap", gap: "8px" }}>
                    {dockTypeOptions.map((type, index) => (
                      <label className={`${dockType === type.value ? "dock-type-txt-active" : "dock-type-txt-inactive"}`}>
                        <input
                          type="radio"
                          name="options"
                          value={type.value}
                          checked={dockType === type.value}
                          onChange={(event) => {
                            setDockType(event.target.value);
                          }}
                          className="custom-radio"
                        />
                        <span className={`px-2 ${dockType === type.value ? "dock-type-txt-active" : "dock-type-txt-inactive"}`}>{type.label}</span>
                      </label>
                    ))}
                  </div>{" "}
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Vehicle Type</div>

                <div style={{ width: "100%", borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                  <SearchWithAPI onDropdownChange={handleVehicleTypeChange} apiUrl={apiUrl + "vehicletype/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={selectedVehicleType} />
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>Date</div>
                <div style={{ width: "100%" }}>
                  <div style={{ borderRadius: "8px", fontWeight: "500", fontSize: "12px", color: "#172b4d" }}>
                    <DatePicker selected={startDate} onChange={handleDateChange} startDate={startDate} endDate={endDate} selectsRange placeholderText="Select date range" className="form-control rounded-3 custom-datepicker" style={{ backgroundColor: "#F8F8F8", color: "#8790A1", cursor: "pointer" }} />
                  </div>{" "}
                </div>
              </div>
            </div>

            <div className="col-12 mt-4 d-flex justify-content-between" style={styles.modalFooter}>
              <button className="btn btn-light" style={styles.resetButton} onClick={handleReset}>
                Reset
              </button>
              <button className="btn btn-danger" style={styles.applyButton} onClick={getDockList}>
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getAvailableDocks = async () => {
    try {
      const response = await getAvailableDocksApi();
      if (response.data.success === true) {
        setAvailableDockList(response.data.docks);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  // const getFilterDockList = async () => {
  //   try {
  //     //'sortBy=$sortbyorder&sortByField=$sortbyfiledname&location_id=${filterby[0]['Locationid']}&dock_id=${filterby[0]['dockid']}&dock_type=${filterby[0]['docktypeid']}&vehicletype_id=${filterby[0]['vehicletypeid']}&from_dock_in=${filterby[0]['from_dock_in']}&to_dock_in=${filterby[0]['to_dock_in']}&from_dock_out=${filterby[0]['from_dock_out']}&to_dock_out=&status=${filterby[0]['to_dock_out']}&search=&limit=$itemperpagecount&skip=${currentPages * itemperpagecount}'
  //     const response = await getDockListApi(`search=${searchText}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&location_id=${selectedLocation}&dock_id=${dockNumberOption}&dock_type=${dockType}&vehicletype_id=${selectedVehicleType}&from_date=${startDate}&to_date=${endDate}`);
  //     if (response.data.success === true) {
  //       setDockList(response.data.docks);
  //     }
  //     return response.data;
  //   } catch (err) {
  //     console.error("Error fetching category:", err);
  //   } finally {
  //   }
  // };

  useEffect(() => {
    if(dockId!=null){
    setIsModalOpen(true);
  }
  }, [dockId]);

    useEffect(() => {
    if(dockOutId!=null){
    setDockOutModal(true);
  }
  }, [dockOutId]);

  useEffect(() => {
    if(selectedLocation==null && selectedVehicleType== null && dockNumberOption==null && dockType==="" && startDate==null && endDate==null){
      getDockList();
    }
  }, [itemsPerPage, itemOffset, searchText,sortField,sortDir,selectedLocation, dockNumberOption, dockType, selectedVehicleType, startDate, endDate]);

  useEffect(() => {
  handleReset();
  }, [selectedStatus]);
  
  const getDockList = async () => {
    try {
      //'sortBy=$sortbyorder&sortByField=$sortbyfiledname&location_id=${filterby[0]['Locationid']}&dock_id=${filterby[0]['dockid']}&dock_type=${filterby[0]['docktypeid']}&vehicletype_id=${filterby[0]['vehicletypeid']}&from_dock_in=${filterby[0]['from_dock_in']}&to_dock_in=${filterby[0]['to_dock_in']}&from_dock_out=${filterby[0]['from_dock_out']}&to_dock_out=&status=${filterby[0]['to_dock_out']}&search=&limit=$itemperpagecount&skip=${currentPages * itemperpagecount}'
      const response = await getDockListApi(`search=${searchText}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&location_id=${selectedLocation ? selectedLocation.value : ""}&dock_id=${dockNumberOption ? dockNumberOption.value : ""}&dock_type=${dockType}&vehicletype_id=${selectedVehicleType ? selectedVehicleType.value : ""}&from_date=${fromCreatedDate}&to_date=${toCreatedDate}&status=${selectedStatus}&sort_field=${sortField}&sort_dir=${sortDir}`);
      if (response.data.success === true) {
        setDockCount(response.data.count);
        setDockList(response.data.docks);
        setPageCount(response.data.total_pgs);
        console.log(itemOffset);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
   const listCount = (menu) => {
    switch (menu) {
      case "All":
        return dockCount?.all??0;
      case "In-Queue":
        return dockCount?.in_queue??0;

      case "Dock-In":
        return dockCount?.dock_in??0;

      case "On-Time":
        return dockCount?.on_time??0;
      case "Delay":
        return dockCount?.delay??0;
      case "Over-Delay":
        return dockCount?.over_delay??0;
      case "Dock-Out":
        return dockCount?.dock_out??0;
      case "Out-Queue":
      return dockCount?.out_queue??0;
      default:
        return  0;
    }

  };
  const onSuccess = async (response) => {
    setIsAddDockModalOpen(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getDockList();
    getAvailableDocks();
  };
  const onSuccessDockOut = async (response) => {
    setDockOutModal(false); 
    setDockOutId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getDockList();
    getAvailableDocks();
  };
  return (
    <div className="content_container"
      /* style={{
        padding: "20px",
        fontFamily: "Epilogue",
        background: "#f9fafb",
        minHeight: "100vh",
      }} */>
           {showDockOutModal && <DockOutModal dockId={dockOutId} onProceed={onSuccessDockOut} onCancel={() => { setDockOutModal(false); setDockOutId(null) }} />}
      <div className="d_series">
        <button type="button" className="d_sers_btn" onClick={() => handleScroll("left")}>
          <img src={left} alt="left" srcset="" />
        </button>
        <span className="scroller" ref={scrollRef}>
          {availableDockList.map((item, index) => (
            <div className={`${item.available_status === true ? "available_box" : ""} ${item.available_status === false && item.current_status === "ontime" ? "on_time_box" : ""} ${item.available_status === false && item.current_status === "delay" ? "delay_box" : ""} ${item.available_status === false && item.current_status === "overdelay" ? "over_delay_box" : ""}`} key={"avail_dock" + index}>
              <div>
                <div className={`${item.available_status === true ? "available_text_1" : ""} ${item.available_status === false && item.current_status === "ontime" ? "on_time_text_1" : ""} ${item.available_status === false && item.current_status === "delay" ? "delay_text_1" : ""} ${item.available_status === false && item.current_status === "overdelay" ? "over_delay_text_1" : ""}`}>{item.display_name}</div>
                <div className={`${item.available_status === true ? "available_text_2" : ""} ${item.available_status === false && item.current_status === "ontime" ? "on_time_text_2" : ""} ${item.available_status === false && item.current_status === "delay" ? "delay_text_2" : ""} ${item.available_status === false && item.current_status === "overdelay" ? "over_delay_text_2" : ""}`}>
                  {item.available_status ? "Available" : ""}
                  {item.available_status === false && (
                    <div style={{ width: "50px" }}>
                    {item.duration!=null &&(<Timer key={"overdelay_timer" + index} initialSeconds={parseDuration(item.duration)} />)}  
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </span>

        <button type="button" className="d_sers_btn" onClick={() => handleScroll("right")}>
          <img src={right} alt="right" srcset="" />
        </button>
      </div>

      {/* group2 btns */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px", justifyContent: "space-between", marginTop: "16px" }}>
        <Row style={{ width: "100%", alignItems: "center", justifyContent: "space-between" }}>
          <Col sm={12} md={5} lg={6}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", height: "40px" }}>
              <button type="button" className="d_sers_btn" onClick={() => handleStatusScroll("left")} style={{ height: "36px", width: "18px", display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 5px" }}>
                <img src={left} alt="left" style={{ width: "10px" }} />
              </button>
              <div style={{ flex: 1, overflow: "hidden" }}>
                <div ref={statusScrollRef} style={{ width: "100%", gap: "12px", whiteSpace: "nowrap" }} className="d-flex hide-scroll">
                  {statusOptions.map((btn, i) => (
                    <button key={i} onClick={() => handleStatusClick(btn)} style={{ background: selectedStatus === btn ? "#ef4444" : "#FFFFFF", color: selectedStatus === btn ? "#ffffff" : "#111827", padding: "8px 16px 10px 16px", border: "0.6px solid #DCDFE4", borderRadius: "12px", cursor: "pointer", fontFamily: "Epilogue", fontSize: "13px", fontWeight: "600", gap: "8px", height: "36px" }}>
                      {btn} {"(" + listCount(btn) + ")"}
                    </button>
                  ))}
                </div>
              </div>
              <button type="button" className="d_sers_btn" onClick={() => handleStatusScroll("right")} style={{ height: "36px", width: "18px", display: "flex",   alignItems: "center", justifyContent: "center", padding: "10px 5px" }}>
                <img src={right} alt="right" style={{ width: "10px" }} />
              </button>
            </div>
          </Col>

          <Col sm={12} md={7} lg={6} style={{ gap: "10px" }} className="style-justify-end">
            <div className="search-box flex items-center border rounded-md w-full md:w-auto">
              <span className="icon mr-2">
                <img src={search} alt="search" className="search-icon w-4 h-4" />
              </span>
              <input type="text" placeholder="Search" className="outline-none w-full" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
            </div>

            <button className="btn rounded-3 me-2" style={{ borderColor: "#dcdfe4", background:'#FFFFFF' }}>
              <img src={df} />
              <select style={{ outline: "none", border: "none" }} value={selectedValue} onChange={handleChange}>
                <option value="">Default (data created)</option>
                <option value="name asc">Name (Asc)</option>
                <option value="name desc">Name (Dsc)</option>
                <option value="created asc">Date (Oldest)</option>
                <option value="created desc">Date (Newest)</option>
              </select>
            </button>

            <div className="filter-dropdown relative">
              <button className="bttn filter-toggle flex items-center border rounded-md" onClick={() => setIsFilterOpen(true)}>
                <span className="icon">
                  <img src={filter} alt="filter" className="btn-icon w-4 h-4" />
                </span>
                Filter
              </button>
            </div>
            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "36px",
                background: "#ffff",
                justifyContent: "center",
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "0 8px",
              }}>
              <button
                style={{
                  borderRight: "1px solid #ccc",
                  borderLeft: "none",
                  borderTop: "none",
                  borderBottom: "none",
                  padding: "6px 8px",
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  height: "100%", // Make button take full height of container
                  display: "flex",
                  alignItems: "center",
                }}
                title="Icon 1">
                <img src={table} alt="Icon 1" style={{ width: "18px", height: "18px" }} />
              </button>
              <button
                style={{
                  border: "none",
                  padding: "6px 8px",
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  height: "100%", // Make button take full height of container
                  display: "flex",
                  alignItems: "center",
                }}
                title="Icon 2">
                <img src={column} alt="Icon 2" style={{ width: "18px", height: "18px" }} />
              </button>
            </div> */}
          </Col>
        </Row>
      </div>

      {/* Table Section */}
      <div
        style={{
          overflowX: "auto",
          background: "#fff",
          borderRadius: "8px",
          padding: "10px",
          color: "#172B4D",
          fontFamily: "Epilogue",
        }}>
        <div className="table-container table-responsive">
          <table className="dock-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {/*  <th style={{ height: "44px", padding: "8px 8px" }}>  
                  <input type="checkbox" />
                </th> */}
                <th style={{ height: "44px", padding: "8px 8px" }}>Vehicle Number</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Driver Name</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Dock</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Date</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Dock In Time</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Dock Out Time</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Status</th>
                <th style={{ height: "44px", padding: "8px 8px" }}>Duration</th>
              </tr>
            </thead>
            <tbody>
              {dockList?.map((dockItem, index) => (
                <tr
                  key={"dock_table_" + index}
                  style={{
                    backgroundColor: hoveredRow === index ? "#F5F5F5" : "#ffffff",
                    cursor: "pointer",
                    transition: "border-color 0.3s",
                    borderLeft: hoveredRow === index ? "3px solid #ef4444" : "3px solid #E5E5E5",
                  }}
                  onMouseEnter={() => setHoveredRow(index)}
                  onMouseLeave={() => setHoveredRow(null)}
                  onClick={() => 
                    setDockId(dockItem.id)
                  } // Open modal on row click setIsModalOpen(true)
                >
                  {/* <td style={{ height: "44px", padding: "8px 8px" }}> 
                  <input type="checkbox" onClick={(e) => e.stopPropagation()} />
                  </td> */}
                  <td className="overflow-hidden" style={{ height: "44px", width: "200px", maxWidth: "200px",  padding: "8px 8px", fontWeight: "bold" }}>{dockItem.vehicle_number ?? ""}</td>
                  <td className="overflow-hidden" style={{ height: "44px", width: "250px", maxWidth: "250px", padding: "8px 8px",  }}>{dockItem.driver_name ?? ""}</td>
                  <td style={{ height: "44px", width: "150px", padding: "8px 8px", }}>{dockItem.display_name ?? ""}</td>
                  <td className="overflow-hidden" style={{ height: "44px", width: "150px", padding: "8px 8px", }}>{dockItem.date ?? ""}</td>
                  <td className="overflow-hidden" style={{ height: "44px", width: "150px", padding: "8px 8px" }}>{dockItem.in_time ?? ""}</td>
                  <td className="overflow-hidden" style={{ height: "44px", width: "150px", padding: "8px 8px" }}>{dockItem.out_time ?? ""}</td>
                  <td className="overflow-hidden" style={{ height: "44px", width: "130px", padding: "8px 8px" }}>
                    <div>{dockItem.dock_status ?? ""}</div>
                   {/*  <div onClick={(e) => e.stopPropagation()}>
                      <select
                        style={{
                          background: hoveredRow === index ? "#ffff" : "#F8F8F8",
                          padding: "10px 16px",
                          border: "none",
                          borderRadius: "10px",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}>
                        <option>Queue</option>
                        <option>Dock In</option>
                        <option>Over Time</option>
                        <option>Delay</option>
                        <option>Dock Out</option>
                      </select>
                    </div> */}
                  </td>
                  <td className="overflow-hidden" style={{ width: "140px", height: "44px", padding: "12px 16px", position: "relative", textAlign: "center" }}>
                    <span className="time-value">{dockItem.duration ?? ""}</span>
                    <div
                      style={{
                        position: "absolute",
                        right: "5px",
                        display: "flex",
                        gap: "5px",
                        background: "#F5F5F5",
                        visibility: hoveredRow === index ? "visible" : "hidden",
                        justifyContent: "center",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}>
                      {/* <button
                        style={{
                          background: "#ffff",
                          border: "1px solid #E5E5E5",
                          borderRadius: "100px",
                          padding: "12px",
                          cursor: "pointer",
                        }}
                        
                        title="Edit">
                        <img src={edit} alt="Edit" style={{ width: "16px", height: "16px" }} />
                      </button>
                      <button
                        style={{
                          background: "#ffff",
                          border: "1px solid #E5E5E5",
                          borderRadius: "100px",
                          padding: "12px",
                          cursor: "pointer",
                        }}
                        title="Delete">
                        <img src={del} alt="Delete" style={{ width: "16px", height: "16px" }} />
                      </button> */}
                       {dockItem.in_time!==null && dockItem.in_time!=="" && dockItem.out_time ===null && (
                              <div className="style-justify-center">
                                <div className="d-flex align-items-center justify-content-center" style={{cursor:'pointer', background:'#D35258', borderRadius:'100px',width:'112px', height:'33px', fontSize:'14px', fontWeight:'700',color:'#FFFFFF'}}
                                  
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDockOutId(dockItem.id)
                                   /*  setVisitorDetails(visitor);
                                    setSelectedStatus("Reject"); */
                                  }}
                                >
                                  Dock Out
                                </div>
                                
                              </div>
                            )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Row>
        <Col>
          <div className="d-flex align-items-center justify-content-start mx-3">
            <span
              style={{
                fontFamily: "Epilogue",
                fontSize: "13px",
                fontWeight: "500",
                color: "#212129",
              }}>
              Records per page :
            </span>
            <select
              className="select3"
              id="perpage"
              value={itemsPerPage}
              onChange={(event) => {
                setItemsPerPage(event.target.value);
              }}
              style={{
                cursor: "pointer",
                fontFamily: "Epilogue",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "18.9px",
                color: "#212129",
                width: "56px",
                height: "24px",
                borderRadius: "10px",
                border: "0.7px solid #E5E5E5",
                padding: "0 4px",
                backgroundColor: "#FFFFFF",
              }}>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </Col>
        <Col>
          <div className="d-flex justify-content-end">
            <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount+1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
          </div>
        </Col>
      </Row>
      <div style={{ textAlign: "center", marginTop: "50px", fontWeight: "400", fontSize: "12px", color: "#172B4D" }}>
        Powered by{" "}
        <span>
          <img src={mawalog} />
        </span>
      </div>

      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: isModalOpen ? "rgba(0, 0, 0, 0.5)" : "transparent",
          transition: "background-color 0.5s ease-in-out",
          zIndex: 999, // Below the modal but above other content
          pointerEvents: isModalOpen ? "auto" : "none",
        }}></div>
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: isModalOpen ? 0 : "-100%", // Slide-in animation from the right
            width: windowWidth <= 640 ? "100%" : windowWidth <= 1024 ? "80%" : "50%", // Responsive width
            height: "100%",
            backgroundColor: "#fff",
            zIndex: 1000,
            transition: "right 0.5s ease-in-out", // Smooth animation
            boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.1)",
          }}>
          <div
            style={{
              padding: "20px",
              height: "100%",
              overflowY: "auto",
            }}>
            <Viewdock dockId={dockId} show={isModalOpen} setIsModalOpen={setIsModalOpen} onClose={() => {setDockId(null); setIsModalOpen(false);}} onSuccess={onSuccessDockOut}/>
          </div>
        </div>
      )}

      {isAddDockModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Light black background
            zIndex: 999,
          }}></div>
      )}
      {isAddDockModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: isAddDockModalOpen ? 0 : "-100%", // Slide-in animation from the right
            width: windowWidth <= 640 ? "100%" : windowWidth <= 1024 ? "80%" : "50%", // Responsive width
            height: "100%",
            backgroundColor: "#fff",
            zIndex: 1000,
            transition: "right 0.5s ease-in-out", // Smooth animation
            boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.1)",
          }}>
          <div
            style={{
              padding: "20px",
              height: "100%",
              overflowY: "auto",
            }}>
            <AddDock onSuccess={onSuccess} onClose={() => setIsAddDockModalOpen(false)} />
          </div>
        </div>
      )}

      {isFilterOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}>
          <div
            className="modal-content"
            style={{
              position: "relative",
              width: "320px",
              height: "100%",
              marginLeft: "auto",
              backgroundColor: "#fff",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
            }}>
            <FilterPanel isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} onApply={handleFilterApply} initialFilters={filterParams} />
          </div>
          
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Dock;

const Timer = ({ displayName, initialSeconds }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    /* if (secondsLeft <= 0) return; */

    const timerId = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, [secondsLeft]);

  return (
    <div /* style={{ marginBottom: "10px" }} */>
      <span>{formatDuration(secondsLeft)}</span>
    </div>
  );
};

const formatDuration = (totalSeconds) => {
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const parseDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr?.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
